/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Email_RequiredInputs */

const en_auth_login_email_required = /** @type {(inputs: Auth_Login_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your email`)
};

const es_auth_login_email_required = /** @type {(inputs: Auth_Login_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu email`)
};

/**
* | output |
* | --- |
* | "Please enter your email" |
*
* @param {Auth_Login_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_login_email_required = /** @type {((inputs?: Auth_Login_Email_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Email_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_email_required(inputs)
	return es_auth_login_email_required(inputs)
});